import React from 'react';
import { useSelector } from 'react-redux';
import SignForm from 'Components/SignForm';
import { DocumentTypes } from 'Interfaces/Document';
import { selectUser } from 'Utils/selectors';

function OnlyOthers() {
  const { email } = useSelector(selectUser);

  return (
    <SignForm
      initialValues={{
        type: DocumentTypes.OTHERS,
        signers: [{ name: 'Me (now)', email, isPreparer: true, order: -1 }, { order: 1 }],
      }}
    />
  );
}

export default OnlyOthers;
